import { LitElement, css, html } from 'lit-element';

import Cookies from 'js-cookie';
import { ROUTES } from '../constants/routes';
import { getClaimsLoginPageUrl } from '../functions/changePage';
import { getCookieDomain } from '../functions/getCookieDomain';
import { exportIcon } from './htPandoraIcons';
import { htPandoraNavigationStyles } from './styles/ht-pandora-navigation-styles';

class htPandoraNavigation extends LitElement {
    static get properties() {
        return {
            page: { type: String },
            loggedIn: { type: Boolean },
            open: { type: Boolean },
            _links: { type: Array },
        };
    }

    constructor() {
        super();

        this.open = false;
        this._links = [
            {
                name: 'Search',
                link: ROUTES.SEARCH,
                active: [ROUTES.SEARCH],
                newLink: null,
                loggedInOnly: true,
                icon: 'search',
                subLinks: null,
            },
            {
                name: 'Accounts',
                link: ROUTES.ACCOUNTS,
                active: [ROUTES.ACCOUNTS, ROUTES.ACCOUNT, ROUTES.ACCOUNT_NEW],
                newLink: ROUTES.ACCOUNT_NEW,
                loggedInOnly: true,
                icon: 'account',
                subLinks: [
                    {
                        name: 'Referrals',
                        link: ROUTES.REFERRALS,
                        active: [ROUTES.REFERRALS, ROUTES.REFERRAL, ROUTES.REFERRAL_NEW],
                        newLink: ROUTES.REFERRAL_NEW,
                    },
                ],
            },
            {
                name: 'Properties',
                link: ROUTES.PROPERTIES,
                active: [ROUTES.PROPERTIES, ROUTES.PROPERTY, ROUTES.PROPERTY_NEW],
                newLink: ROUTES.PROPERTY_NEW,
                loggedInOnly: true,
                icon: 'property',
                subLinks: null,
            },
            {
                name: 'Contracts',
                link: ROUTES.CONTRACTS,
                active: [ROUTES.CONTRACTS, ROUTES.CONTRACT, ROUTES.CONTRACT_NEW],
                newLink: ROUTES.CONTRACT_NEW,
                loggedInOnly: true,
                icon: 'contract',
                subLinks: [
                    {
                        name: 'Renewals',
                        link: ROUTES.RENEWALS,
                        active: [ROUTES.RENEWALS, ROUTES.RENEWAL, ROUTES.RENEWAL_NEW],
                        newLink: ROUTES.RENEWAL_NEW,
                    },
                ],
            },
            {
                name: 'Packages',
                link: ROUTES.PRODUCT_PACKAGES,
                active: [
                    ROUTES.PRODUCT_PACKAGES,
                    ROUTES.PRODUCT_PACKAGE,
                    ROUTES.PRODUCT_PACKAGE_NEW,
                ],
                newLink: ROUTES.PRODUCT_PACKAGE_NEW,
                loggedInOnly: true,
                icon: 'product',
                subLinks: [
                    {
                        name: 'Products',
                        link: ROUTES.PRODUCTS,
                        active: [ROUTES.PRODUCTS, ROUTES.PRODUCT, ROUTES.PRODUCT_NEW],
                        newLink: ROUTES.PRODUCT_NEW,
                    },
                ],
            },
            {
                name: 'Pricebooks',
                link: ROUTES.PRICEBOOKS,
                active: [ROUTES.PRICEBOOKS, ROUTES.PRICEBOOK, ROUTES.PRICEBOOK_NEW],
                newLink: ROUTES.PRICEBOOK_NEW,
                loggedInOnly: true,
                icon: 'pricebook',
            },
            {
                name: 'Promo Codes',
                link: ROUTES.PROMO_CODES,
                active: [ROUTES.PROMO_CODES, ROUTES.PROMO_CODE, ROUTES.PROMO_CODE_NEW],
                newLink: ROUTES.PROMO_CODE_NEW,
                loggedInOnly: true,
                icon: 'promo_code',
                subLinks: [
                    {
                        name: 'Families',
                        link: ROUTES.PROMO_CODE_FAMILIES,
                        active: [
                            ROUTES.PROMO_CODE_FAMILIES,
                            ROUTES.PROMO_CODE_FAMILY,
                            ROUTES.PROMO_CODE_FAMILY_NEW,
                        ],
                        newLink: ROUTES.PROMO_CODE_FAMILY_NEW,
                    },
                    {
                        name: 'Types',
                        link: ROUTES.PROMO_CODE_TYPES,
                        active: [
                            ROUTES.PROMO_CODE_TYPES,
                            ROUTES.PROMO_CODE_TYPE,
                            ROUTES.PROMO_CODE_TYPE_NEW,
                        ],
                        newLink: ROUTES.PROMO_CODE_TYPE_NEW,
                    },
                    {
                        name: 'Products',
                        link: ROUTES.PRODUCT_TO_PROMOCODES,
                        active: [
                            ROUTES.PRODUCT_TO_PROMOCODES,
                            ROUTES.PRODUCT_TO_PROMOCODE,
                            ROUTES.PRODUCT_TO_PROMOCODE_NEW,
                        ],
                        newLink: ROUTES.PRODUCT_TO_PROMOCODE_NEW,
                        hide: true,
                    },
                    {
                        name: 'Packages',
                        link: ROUTES.PACKAGE_TO_PROMOCODES,
                        active: [
                            ROUTES.PACKAGE_TO_PROMOCODES,
                            ROUTES.PACKAGE_TO_PROMOCODE,
                            ROUTES.PACKAGE_TO_PROMOCODE_NEW,
                        ],
                        newLink: ROUTES.PACKAGE_TO_PROMOCODE_NEW,
                        hide: true,
                    },
                ],
            },
            {
                name: 'Sales Portal',
                link: ROUTES.SALES_PORTAL,
                active: [ROUTES.SALES_PORTAL],
                newLink: null,
                loggedInOnly: true,
                icon: 'phone',
                subLinks: null,
            },
            {
                name: 'Controller',
                link: ROUTES.CONTROLLER,
                active: [ROUTES.CONTROLLER],
                newLink: null,
                loggedInOnly: true,
                icon: 'controller',
                subLinks: null,
            },
            {
                name: 'Analytics',
                link: ROUTES.ANALYTICS,
                active: [ROUTES.ANALYTICS],
                newLink: null,
                loggedInOnly: true,
                icon: 'analytics',
                subLinks: [
                    {
                        name: 'Engineer Monitoring',
                        link: ROUTES.ANALYTICS_ENGINEER_MONITORING,
                        active: [ROUTES.ANALYTICS_ENGINEER_MONITORING],
                    },
                    {
                        name: 'Claims Dashboard',
                        link: ROUTES.ANALYTICS_CLAIMS_DASHBOARD,
                        active: [ROUTES.ANALYTICS_CLAIMS_DASHBOARD],
                    },
                    {
                        name: 'Cost Control',
                        link: ROUTES.ANALYTICS_COST_CONTROL,
                        active: [ROUTES.ANALYTICS_COST_CONTROL],
                    },
                    {
                        name: 'Ops Queue',
                        link: ROUTES.ANALYTICS_OPS_QUEUE,
                        active: [ROUTES.ANALYTICS_OPS_QUEUE],
                    },
                    {
                        name: 'Your Repair ASV',
                        link: ROUTES.ANALYTICS_YOUR_REPAIR_ASV,
                        active: [ROUTES.ANALYTICS_YOUR_REPAIR_ASV],
                    },
                    {
                        name: 'Ops Queue Status Zero',
                        link: ROUTES.ANALYTICS_OPS_QUEUE_STATUS_ZERO,
                        active: [ROUTES.ANALYTICS_OPS_QUEUE_STATUS_ZERO],
                    },
                ],
            },
        ];
    }

    _logOut() {
        const domain = getCookieDomain(process.env.ENVIRONMENT);
        Cookies.set('isLoggingOut', true, { domain });
        const claimsLoginUrl = getClaimsLoginPageUrl();
        window.location.assign(claimsLoginUrl);
    }

    _renderLink(linkObject) {
        let activeUrls = linkObject.active;
        if (linkObject.subLinks) {
            linkObject.subLinks.forEach((subLink) => {
                activeUrls = activeUrls.concat(subLink.active);
            });
        }

        if (linkObject.hide) return;

        let navLink = linkObject.link;

        if (linkObject.link === ROUTES.PRICEBOOKS) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.PRICEBOOKS}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.PRICEBOOKS}`;
            }
        }

        if (linkObject.link === ROUTES.CONTRACTS) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.CONTRACTS}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.CONTRACTS}`;
            }
        }

        if (linkObject.link === ROUTES.ACCOUNTS) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ACCOUNTS}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ACCOUNTS}`;
            }
        }

        if (linkObject.link === ROUTES.PROPERTIES) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.PROPERTIES}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.PROPERTIES}`;
            }
        }

        if (linkObject.link === ROUTES.SALES_PORTAL) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.SALES_PORTAL}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.SALES_PORTAL}`;
            }
        }

        if (linkObject.link === ROUTES.SEARCH) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.SEARCH}`;

            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.SEARCH}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_ENGINEER_MONITORING) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_ENGINEER_MONITORING}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_ENGINEER_MONITORING}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_CLAIMS_DASHBOARD) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_CLAIMS_DASHBOARD}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_CLAIMS_DASHBOARD}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_COST_CONTROL) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_COST_CONTROL}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_COST_CONTROL}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_OPS_QUEUE) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_OPS_QUEUE}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_OPS_QUEUE}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_YOUR_REPAIR_ASV) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_YOUR_REPAIR_ASV}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_YOUR_REPAIR_ASV}`;
            }
        }

        if (linkObject.link === ROUTES.ANALYTICS_OPS_QUEUE_STATUS_ZERO) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_OPS_QUEUE_STATUS_ZERO}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.ANALYTICS}/${ROUTES.ANALYTICS_OPS_QUEUE_STATUS_ZERO}`;
            }
        }

        if (linkObject.link === ROUTES.CONTROLLER) {
            navLink = `https://new.${window.location.hostname}/${ROUTES.CONTROLLER}`;
            if (process.env.ENVIRONMENT === 'local') {
                navLink = `http://localhost:3000/${ROUTES.CONTROLLER}`;
            }
        }

        return html`
            <li
                class="navigation__item ${linkObject.subLinks
        ? 'navigation__item--has-sublinks'
        : ''} ${activeUrls.includes(this.page) ? 'active' : ''}"
                @click="${() => (this.open ? (this.open = !this.open) : null)}"
            >
                <a class="navigation__link" href="${navLink}">
                    ${linkObject.icon ? exportIcon(linkObject.icon) : ''}
                    <p>${linkObject.name}</p>
                </a>
                ${linkObject.newLink
        ? html`
                          <a class="navigation__link__plus" href="${linkObject.newLink}">
                              ${exportIcon('plus')}
                          </a>
                      `
        : ''}
                ${linkObject.subLinks
        ? html`
                          <ul class="navigation__list">
                              ${linkObject.subLinks.map(subLinkObject => this._renderLink(subLinkObject))}
                          </ul>
                      `
        : ''}
            </li>
        `;
    }

    static get styles() {
        return css`
            ${htPandoraNavigationStyles}
        `;
    }

    render() {
        return html`
            <nav class="navigation ${this.open ? 'open' : ''}">
                <div class="navigation-toggle" @click="${() => (this.open = !this.open)}">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div
                    class="navigation__logo"
                    @click="${() => (this.open ? (this.open = !this.open) : null)}"
                >
                    <a
                        class="navigation__link navigation__link--home ${this.page === ROUTES.HOME
        ? 'active'
        : ''}"
                        href="${ROUTES.HOME}"
                    >
                        <p>Pandora</p>
                    </a>
                </div>
                <ul class="navigation__list scroll-none">
                    ${this.loggedIn
        ? this._links.map(linkObject => this._renderLink(linkObject))
        : ''}
                    <li
                        class="navigation__item ${this.page === ROUTES.LOGIN ? 'active' : ''}"
                        @click="${() => (this.open ? (this.open = !this.open) : null)}"
                    >
                        <button class="navigation__link" @click="${() => this._logOut()}">
                            ${exportIcon('lock')}
                            <p>${this.loggedIn ? 'Logout' : 'Login'}</p>
                        </button>
                    </li>
                </ul>
                <div class="nav-version">Version: <i>Tulkun 1.0.1</i></div>
            </nav>
        `;
    }
}

window.customElements.define('ht-pandora-navigation', htPandoraNavigation);
